import {
  GET_USER_DETAILS_RESPONSE,
  UPDATE_USER_STATUS_BY_USER_ID_RESPONSE,
} from "./actionTypes";

import produce from "immer";

export const initialState = {
  userDetailApiResponse: null,
  userDetailData: [],
};

const userMgmt = (state = initialState, action) =>
  produce(state, (draft) => {
    let response;
    switch (action.type) {
      case GET_USER_DETAILS_RESPONSE:
        response = action.payload.apiResponse;
        if (response.isSuccessResponse) {
          draft.userDetailData = response.responseData;
        } else {
          draft.userDetailData = null;
        }
        break;

      case UPDATE_USER_STATUS_BY_USER_ID_RESPONSE:
        draft.userDetailApiResponse = action.payload.apiResponse;
        break;

      default:
        state = { ...state };
        break;
    }
  });

export default userMgmt;
